import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
// import Cookies from "universal-cookie";
// const cookies = new Cookies();

const NewsLine = () => {
  const DD = useSelector((e: any) => e.domainDetails);
  // const authToken = cookies.get("skyTokenFront");
  const [popUp, setPopUp] = useState<boolean>(false);
  const fakeNews = "Welcome to SkyBook! Enjoy live sports betting, instant withdrawals, best odds, and 24/7 customer support. Place your bets now!";
  const newsMessage = DD?.maintenanceMessage || DD?.userMessage || fakeNews;
  const secondaryNewsMessage = DD?.agentMessage || DD?.maintenanceMessage || fakeNews;

  return (
    <>
      <div className="marquee-box" style={{ display: "flex" }}>
        <h4 className="px-3">
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 1024 1024"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z"></path>
          </svg> */}
          <img src="/images/microphone.webp" alt="Microphone" style={{ width: "16.64px", height: "16.64px", maxHeight: "16.64px", maxWidth: "16.64px" }} />
        </h4>
        <div className="marquee">
          <div className="js-marquee-wrapper">
            <a onClick={() => setPopUp(true)} style={{ fontSize: "11.44px" }}>
              {newsMessage}
            </a>
          </div>
        </div>
      </div>
      {popUp && (
        <div className="announcement-modal modal-show">
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-between">
              <h4 className="text-center">Announcement</h4>
              <div className="close" onClick={() => setPopUp(false)}></div>
            </div>
            <div className="modal-body">
              <span className="ver-tag">{moment().format("M.D.YYYY")}</span>

              <p>{newsMessage}</p>
              <div className="line"></div>
              <span className="ver-tag">{moment().format("M.D.YYYY")}</span>
              <p>{secondaryNewsMessage}</p>

              <div className="line"></div>
            </div>
          </div>
        </div>
      )}
      {/* ) : (
        ""
      )} */}
    </>
  );
};

export default NewsLine;
